@if (valveDataPoint$ | async) {
  <app-chart-tile
    [title]="getTitle() | translate"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
